import { AnchorIds } from "./TourTypes";
import { SudoButton } from "../../sudokit/components/SudoButton";
import StickyNoteAnchor from "./StickyNoteAnchor";
import { useExitTour } from "./useExitTour";

function ExitTourButton() {
  const exitTour = useExitTour();

  return (
    <>
      <StickyNoteAnchor anchorId={AnchorIds.EXIT_TOUR_BUTTON} />
      <SudoButton
        rightIcon="/assets/close.svg"
        className="text-app-grey-0 font-semibold relative z-[110000]"
        data-sticky-tour-exit
        onClick={exitTour}
      >
        Exit Tour
      </SudoButton>
    </>
  );
}

export default ExitTourButton;
